module.exports = __webpack_public_path__ + "img/juntos_motion.2ab4fb75.gif";